import { SATSPERBITCOIN } from "./math";
const PAYMENT_DESCRIPTION = "Blitz Point-of-sale";
const ACCOUNT_LOCAL_STORAGE = "Account";
const SERVER_LOCAL_STORAGE = "Server_name";
const POS_SETTINGS_LOCAL_STORAGE = "POS_SETTINGS";
const BITCOIN_SATS_ICON = "₿";
export {
  SATSPERBITCOIN,
  PAYMENT_DESCRIPTION,
  ACCOUNT_LOCAL_STORAGE,
  SERVER_LOCAL_STORAGE,
  BITCOIN_SATS_ICON,
  POS_SETTINGS_LOCAL_STORAGE,
};
